<div class="notficationIcon">
  <span class="ballIcon" (click)="goNotification()" ></span>
  <span
    class="badge"
    [routerLink]="['/notifications-all']"
    *ngIf="totalNotificationCount > 0"
    >{{ totalNotificationCount }}</span
  >
</div>
